module.exports = "<div class=\"loading-container\" [class.active]=\"isActive\">\n  <div class=\"loading-icon\"></div>\n  <div class=\"app-preview-loader-text\">\n    <div class=\"preview-title\">Loading Preview</div>\n    <div class=\"preview-text\"><i>Hang tight while we load your content</i></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/inline-spinner-loader/inline-spinner-loader.component.html
// module id = ../../../../../src/app/shared/components/inline-spinner-loader/inline-spinner-loader.component.html
// module chunks = 12